<ng-dialog-header title="Original Location"></ng-dialog-header>
<mat-dialog-content class="d-flex flex-row flex-grow-1">
  <ns-grid [name]="configs.gridName" [gridTitle]="configs.gridTitle" [columns]="configs.columns" [data]="moves"
           [config]="configs.headerOptions" [gridOptions]="configs.options" [loading]="loading"
           [rowSelection]="configs.rowSelection">
  </ns-grid>
</mat-dialog-content>
<ng-dialog-footer class="d-flex justify-content-end w-100">
</ng-dialog-footer>
